import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="flex-1 relative min-h-[350px] lg:min-h-[500px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20mysterious%20night%20scene%20with%20urban%20cityscape%2C%20dark%20alley%20atmosphere%2C%20neon%20pink%20accents%2C%20cinematic%20noir%20style%2C%20film%20grain%2C%20editorial%20photography%2C%20high%20contrast%2C%20moody%20lighting%2C%20mysterious%20vibe&width=900&height=700&seq=cta-left-2026&orientation=landscape"
          alt="独家爆料"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 p-8 md:p-10">
          <span className="text-xs text-primary-300 tracking-widest uppercase">独家 · 深度</span>
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-background-50 leading-none mt-3 tracking-tight">
            一手爆料
            <br />
            快人一步
            <br />
            永不掉队
          </h3>
        </div>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center px-6 py-14 md:py-20 bg-background-50">
        <div className="max-w-md text-center">
          <h3 className="text-3xl md:text-4xl font-heading font-black text-foreground-950 leading-tight tracking-tight">
            加入吃瓜
            <br />
            第一梯队
          </h3>
          <p className="mt-4 text-sm text-foreground-500 leading-relaxed">
            海量独家爆料每日更新，深度揭秘圈内热点内幕。吃瓜群众聚集地，全网娱乐八卦资源一网打尽，24小时不打烊，随时等你回家！
          </p>
          <Link
            to="/category/meiri-dasai"
            className="inline-flex items-center gap-2 mt-8 px-8 py-4 bg-foreground-950 text-background-50 font-semibold text-sm rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即开始吃瓜
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}